import { TrackedQuery } from '@ih/app/client/shared/interfaces';

export class SetTrackedQueries {
  public static readonly type = '[Notifications] SetTrackedQueries';
  constructor(public readonly trackedQueries: TrackedQuery[]) {}
}
